import SectionHeader from '../SectionHeader';
import SortableWrapper from '../../components/Wrappers/SortableWrapper';
import { ReactSortable } from 'react-sortablejs';
import { checkIsSummaryBox } from './utils';
import SummaryBox from './SummaryBox';
import BorderBox from '../../components/Wrappers/BorderBox';
import SubmitModal from '../../components/Modal/index';
import { handleClose } from '../../components/Modal/utils';
import { progressiveFormStepper } from '../../components/ProgressiveFormStepper/utils';
import { Box, Button, Grid, Link, useStyleConfig } from '@chakra-ui/react';
import { exitToMenu } from '../utils';
import DoneButton from './DoneButton';
import { handleEditable } from './SummaryBox/utils';

const MultipleSection = (props, formikProps) => {
  const values = formikProps.values;
  const sectionName = props.stateProps.sectionData.sectionName;
  const navSection = props.navSections[sectionName];
  props.formikProps = formikProps;
  const styles = props.stateProps.multisectionStyles;
  const variant = 'wrapper';
  const buttonStyles = useStyleConfig('Button', { variant });
  const menuButtonLabel = sectionName === 'download' ? 'Return' : 'Menu';
  return (
    <>
      <Box display='flex' justifyContent='space-between'><SectionHeader navSection={navSection} props={props} />
      <DoneButton  props={props} formikProps={formikProps}/>
      </Box>
        <SortableWrapper>
        <ReactSortable
          list={values.jobSeekerData}
          setList={props.stateProps.setSortableList}
          handle={'.dragit'}
        >
          <>
            <SubmitModal
              stateProps={props.stateProps}
              formikProps={formikProps}
              handleClose={handleClose}
              message_raw='' />
             {Object.values(values.jobSeekerData).map((secParts, index) => {
              let isSummary =
                checkIsSummaryBox(
                  props.stateProps,
                  index,
                );
              if (isSummary && sectionName !== 'download') {
                return (<SummaryBox props={props} formikProps={formikProps} secOrIndIndex={index} styles={styles}/>)
              } else {
                return (
                  <Box sx={{ marginBottom: '8px' }}>
                    <BorderBox>
                      <Box display='flex' justifyContent='flex-end' width='100%'>
                        {sectionName !== 'download' &&
                        <Link
                          border='1px solid #555'
                          borderRadius='5px'
                          width='2.5rem'
                          padding='.3rem 0 0 .8rem'
                          fontSize='20px'
                          fontWeight='bold'
                          onClick={e => {
                            handleEditable(props.stateProps, -1,0);
                          }}>^
                        </Link>
                        }
                      </Box>
                      <Box sx={{ margin: ['0', null, '28px 20px 20px'] }}>
                        {progressiveFormStepper(
                          props,
                          props.sections['questions'],
                          index,
                        )}
                      </Box>
                    </BorderBox>
                  </Box>
                );
              }
            })}
          </>
        </ReactSortable>

        <Grid templateColumns="repeat(2, 1fr)" gap={6} sx={{ justifyContent: 'space-between' }}>
          <Box>
            <Button
              sx={{...buttonStyles.primary,...buttonStyles.sincleSectionMenu}}
              onClick={() => exitToMenu(props)}
            >
              &lt;&lt; {menuButtonLabel}
            </Button>
          </Box>
          <Box>
          <Button
            sx={{...buttonStyles.done}}
            float='right'
            width='fit-content'
            onClick={() => exitToMenu(props)}
          >
            Done with Experience
          </Button>

          </Box>
        </Grid>
      </SortableWrapper>

    </>
  );
};

export default MultipleSection;
